import clsx from 'clsx'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import TabPanel from '../components/TabPanel'
import Assessments from './assessments'
import AssessmentBank from './assessment-bank'
import QuestionBank from './question-bank'
import Assignments from './assignments'
import BlankAssessmentPdf from '../preview-blank-pdf'


const useStyles = makeStyles(contentStyles)

export default function Content({context}) {
  const {tab: value} = context
  const classes = useStyles()

  const tabProperties = index => ({value, index, className: clsx(classes[index], value == index ? classes.active : undefined)})
  
  return (
    <div className={classes.root}>
      {value != undefined && (<>
        <BlankAssessmentPdf context={context} />
        <TabPanel {...tabProperties("assessments")}>
          <Assessments context={context} />
        </TabPanel>
        <TabPanel {...tabProperties("question-bank")}>
          <QuestionBank />
        </TabPanel>
        <TabPanel {...tabProperties("assessment-bank")}>
          <AssessmentBank context={context} />
        </TabPanel>
        <TabPanel {...tabProperties("assigned")}>
          <Assignments context={context} />
        </TabPanel>
      </>)}
    </div>
  )
}

function contentStyles() {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
    },
    active: {
      display: 'flex',
      flexGrow: 1,
      "& .tab-content": {
        display: 'flex',
        flexGrow: 1,
        border: "solid 1px #e0e0e0",
        borderBottom: "none"
      }
    },
    "question-bank": {
      "& .tab-content": {
        border: 'none',
      }
    },
  }
}
